module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_9005.5da8dfb6.png";